import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

export default class FormatDialog extends React.Component {
  render() {
    let titles = {
      0: languages.structure.onlyGroup,
      1: languages.structure.groupKO,
      2: languages.structure.onlyKO,
    };
    let showPouleForm = false;
    if (this.props.structure === 0 || this.props.structure === 1) {
      showPouleForm = true;
    }
    let showKOForm = false;
    if (this.props.structure === 1 || this.props.structure === 2) {
      showKOForm = true;
    }
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {titles[this.props.structure] || ""}
        </DialogTitle>
        <form>
          {showPouleForm && (
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <Typography>{languages.structure.howManyPoules}</Typography>
              <TextField
                value={this.props.numPoules}
                type="number"
                onChange={this.props.handleChange}
                margin="normal"
                fullWidth
                name="numPoules"
              />
              <br />
              <br />
              <Typography>
                {languages.formatString(
                  languages.structure.howManyTeamsInPoules,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              </Typography>
              <TextField
                value={this.props.pouleSize}
                type="number"
                onChange={this.props.handleChange}
                margin="normal"
                fullWidth
                name="pouleSize"
              />
            </DialogContent>
          )}
          {showKOForm && (
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <Typography>
                {languages.formatString(
                  languages.structure.howManyToKO,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              </Typography>
              <FormControl style={{ marginTop: 20, marginBottom: 5 }}>
                <Select
                  value={this.props.numToKO}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "numToKO",
                    id: "bracket-size",
                  }}
                  style={{ width: 100 }}
                >
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={8}>8</MenuItem>
                  <MenuItem value={16}>16</MenuItem>
                  <MenuItem value={32}>32</MenuItem>
                  <MenuItem value={64}>64</MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
          )}
          <DialogContent style={{ paddingBottom: 5 }}>
            <Typography>{languages.structure.changeLater}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              disabled={
                this.props.pouleSize * this.props.numPoules > 1200 ||
                this.props.pouleSize > 18 ||
                this.props.pouleSize < 2
              }
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.structure.create}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
